import React, { Component } from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import LightSpinnerWrapper from './../Wrappers/LightSpinnerWrapper/LightSpinnerWrapper.jsx';
import TextField from '../../reusable/Form/TextField.jsx';
import SelectField from '../../reusable/Form/Select.jsx';
import TextareaField from '../../reusable/Form/Textarea.jsx';
import utils from '../../utils/utilities.js'
import xhr from './../../utils/xhr';
import { forIn } from 'lodash';

class DeliveryIconsForm extends Component {

    constructor(props) {
        super(props);

        const today = new Date(),
              dd    = today.getDate(),
              mm    = today.getMonth() + 1,
              yyyy  = today.getFullYear();

        this.state = {
            email:               "",
            subject:             this.props.intl.formatMessage(
                {id: 'Entities_Preview_UIText_emailModal.subject.placeholder'}),
            comments:            "",
            attachmentType:      "attachment",
            fileFormat:          "pdf",
            fileName:            this.props.intl.formatMessage(
                {id: 'Entities_Preview_UIText_emailModal.FileName.placeholder'}) + `-${yyyy}-${mm}-${dd}`,
            validationActivated: false,
            isLoading:           false
        }
    }

    changeHandlers = {
        email:          (e) => { this.setState({email: e.target.value}) },
        subject:        (e) => { this.setState({subject: e.target.value}) },
        comments:       (e) => { this.setState({comments: e.target.value}) },
        attachmentType: (e) => { this.setState({attachmentType: e.target.value}) },
        fileFormat:     (e) => { this.setState({fileFormat: e.target.value}) },
        fileName:       (e) => { this.setState({fileName: e.target.value}) }
    }

    errorChecks = {
        email: () => this.state.validationActivated &&
        (this.state.email.length ?
            !utils.isEmailAddressValid(this.state.email) &&
            this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.emailValidationFailure.address'}) :
            this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.emailValidationFailure.address'})),

        subject: () => this.state.validationActivated &&
        !this.state.subject.length &&
        this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.emailValidationFailure.subject'}),

        fileName: () => this.state.validationActivated &&
        this.state.attachmentType === "attachment" && !this.state.fileName.length &&
        this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.emailValidationFailure.fileName'})
    }

    submit(callback, errorCallback) {
        this.setState({validationActivated: true}, () => {
            let validForm = true;
            forIn(this.errorChecks, (hasError) => {
                if (hasError()) {
                    validForm = false
                }
            })

            if (validForm) {
                this.setState({isLoading: true});
                if (this.state.attachmentType !== 'attachment') {
                    return xhr.post({
                        url:  '/api/download/email-with-pdf/',
                        data: {
                            emailAddresses: this.state.email,
                            subject:        this.state.subject,
                            inline:         true,
                            text:           this.state.comments + '<br>' + this.props.pdfContent
                        }
                    }).then((response) => {
                        this.setState({isLoading: false});
                        callback(true);
                    }).catch((error) => {
                        this.setState({isLoading: false});
                        utils.logError(error, 'emailSending.submit():');
                        callback(false);
                    });
                } else {
                    return xhr.post({
                        url:  '/api/download/email-with-pdf/',
                        data: {
                            emailAddresses: this.state.email,
                            subject:        this.state.subject,
                            inline:         false,
                            text:           this.state.comments,
                            attachmentName: this.state.fileName + '.pdf',
                            html:           this.props.pdfContent
                        }
                    }).then((response) => {
                        this.setState({isLoading: false});
                        callback(true);
                    }).catch((error) => {
                        this.setState({isLoading: false});
                        utils.logError(error, 'emailSending.submit():');
                        callback(false);
                    });
                }
            } else {
                if (typeof errorCallback === "function") {
                    errorCallback()
                }
            }
        })
    }

    render() {
        return (
            <LightSpinnerWrapper isLoading={this.state.isLoading}>
                <div id="email-form">
                    <TextField
                        label={this.props.intl.formatMessage(
                            {id: 'Entities_Preview_UIText_emailModal.recipientsEmailAddresses'})}
                        value={this.state.email}
                        onChange={this.changeHandlers.email}
                        hasError={this.errorChecks.email()}
                        classNames="email-address_field"
                        required
                    />
                    <div class="privacy_policy__text">
                        <FormattedMessage id='Entities_Preview_UIText_emailModal.privacyPolicy'/>
                        <a href="https://www.lexisnexis.com/product-resources/nexis/privacy-policy.html"
                           target="_blank"
                           rel="noopener noreferrer">
                            <FormattedMessage id="HeaderFooterNav_Legal_UIText_footer.privacy"/>
                        </a>.
                    </div>
                    <br/>
                    <TextField
                        label={this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.subject'})}
                        value={this.state.subject}
                        onChange={this.changeHandlers.subject}
                        hasError={this.errorChecks.subject()}
                        classNames="subject_field"
                        required
                    />
                    <TextareaField
                        label={<div>{this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.comments'})}
                            <span className="optional_text">{this.props.intl.formatMessage(
                                {id: 'Entities_Preview_UIText_emailModal.optional'})}</span></div>}
                        value={this.state.comments}
                        onChange={this.changeHandlers.comments}
                    />
                    <SelectField
                        label={this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.sendAs'})}
                        value={this.state.attachmentType}
                        onChange={this.changeHandlers.attachmentType}
                        options={[
                            {value:    "attachment",
                                label: this.props.intl.formatMessage(
                                    {id: 'Entities_Preview_UIText_emailModal.sendAs.attachment'})
                            },
                            {value:    "inline",
                                label: this.props.intl.formatMessage(
                                    {id: 'Entities_Preview_UIText_emailModal.sendAs.inline'})
                            }
                        ]}
                    />
                    <SelectField
                        label={this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.fileFormat'})}
                        value={this.state.fileFormat}
                        onChange={this.changeHandlers.fileFormat}
                        options={[
                            {value:    "pdf",
                                label: this.props.intl.formatMessage(
                                    {id: 'Entities_Preview_UIText_emailModal.fileFormat.pdf'})
                            },
                            {value:    "word",
                                label: this.props.intl.formatMessage(
                                    {id: 'Entities_Preview_UIText_emailModal.fileFormat.word'})
                            }
                        ]}
                        disabled={this.state.attachmentType === "inline" || this.state.attachmentType === "attachment"}
                    />
                    <TextField
                        label={this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.FileName'})}
                        value={this.state.fileName}
                        onChange={this.changeHandlers.fileName}
                        hasError={this.errorChecks.fileName()}
                        classNames="file-name_field"
                        disabled={this.state.attachmentType === "inline"}
                        required={this.state.attachmentType === "attachment"}
                    />
                </div>
            </LightSpinnerWrapper>
        )
    }
}

export default injectIntl(DeliveryIconsForm, {withRef: true});


// WEBPACK FOOTER //
// ./src/scripts/reusable/DeliveryIcons/DeliveryIcons.EmailModalForm.jsx